export { CreditCardAlt as default } from './CreditCardAlt';
